import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Drawer, Table, Space, Form, message, Modal, Button, Radio, Input, Checkbox } from 'antd';
import { deleteQuestionsListApi, getQuestionsListApi, updateQuestionsApi, saveQuestionsApi } from '@services/Conference/sign';
import './index.less';
import _ from 'lodash';

// 弹框表单控件布局
const examModalFormItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 20 },
};

// 题目类型
const topicTypeMap = [
    { value: 'radio', label: '单选题' },
    { value: 'checkbox', label: '多选题' },
    { value: 'text', label: '问答题' },
];

// 可选问题管理
const TemplateQuestions = ({ openDrawer, setOpenDrawer, updateList }) => {
    const params = useParams();
    const conferenceId = params?.id; // 会议项目 ID
    const [isEdit, setIsEdit] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();

    // 监听题目类型
    const topicType = Form.useWatch('questionType', form);
    const [questionsList, setQuestionsList] = useState([]);

    const columns = [
        {
            title: '题型',
            dataIndex: 'questionType',
            key: 'questionType',
            width: 100,
            render: (_, record) => {
                return getQuestionType(record.questionType);
            },
        },
        {
            title: '题目内容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            render: (_, record) => (
                <Space size="medium">
                    <a onClick={() => handleEdit(record)}>编辑</a>
                    <a onClick={() => handleDelete(record)}>删除</a>
                </Space>
            ),
        },
    ];

    const getQuestionType = type => {
        switch (type) {
            case 'radio':
                return '单选题';
            case 'checkbox':
                return '多选题';
            case 'text':
                return '问答题';
        }
    };

    const onClose = () => {
        setOpenDrawer(false);
        updateList();
    };

    const handleAdd = () => {
        setIsEdit(false);
        setIsModalOpen(true);
    };

    // 新增题目
    const handleOk = () => {
        form.validateFields().then(async values => {
            const reqParams = {
                ...values,
                activityId: conferenceId,
                activityType: 'conference',
                id: form.getFieldValue('id') || undefined,
            };
            const reqApi = isEdit ? updateQuestionsApi : saveQuestionsApi;
            const res = await reqApi(reqParams);
            if (res && res.status_code === 200) {
                message.success('保存成功');
                setIsModalOpen(false);
                form.resetFields();
                getQuestionsList();
            }
        });
    };

    // 编辑题目
    const handleEdit = row => {
        setIsEdit(true);
        form.setFieldsValue({
            content: row.content,
            questionType: row.questionType,
            options: (row.options || []).map(item => ({ id: item.id, content: item.content })),
            id: row.id,
        });
        setIsModalOpen(true);
    };

    // 删除题目
    const handleDelete = row => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: `确认删除该题目？`,
            okText: '确认',
            centered: true,
            cancelText: '取消',
            onOk: async () => {
                const res = await deleteQuestionsListApi({ id: row.id });
                if (res && res.status_code === 200) {
                    message.success('删除成功！');
                    getQuestionsList();
                }
            },
        });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    // 题目列表
    const getQuestionsList = async () => {
        const res = await getQuestionsListApi({ activityId: conferenceId, activityType: 'conference' });
        if (res && res.status_code === 200) {
            setQuestionsList(res.data);
        }
    };

    useEffect(() => {
        if (openDrawer) {
            getQuestionsList();
        }
    }, [openDrawer]);

    // 编辑题型切换时 - 赋值默认选项
    useEffect(() => {
        if (topicType === 'radio' || topicType === 'checkbox') {
            console.log(form.getFieldsValue(), _.isEmpty(form.getFieldValue('options')));
            if (_.isEmpty(form.getFieldValue('options'))) {
                form.setFieldValue('options', [{ content: '' }, { content: '' }, { content: '' }, { content: '' }]);
            }
        }
    }, [topicType]);

    return (
        <>
            <Drawer title="可选问题管理" placement="right" onClose={onClose} open={openDrawer} size={800} className="template-questions-drawer" closable={{ placement: 'end' }}>
                <Button type="primary" onClick={handleAdd} className="add-question-btn">
                    新增问题
                </Button>
                <Table dataSource={questionsList} columns={columns} pagination={false} />
            </Drawer>

            <Modal title={isEdit ? '编辑题目' : '新增题目'} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={830} okText="保存" className="template-questions-management" destroyOnHidden>
                <Form form={form} {...examModalFormItemLayout} initialValues={{ questionType: 'radio' }}>
                    <Form.Item name="questionType" label="问题类型" rules={[{ required: true, message: '请选择问题类型' }]}>
                        <Radio.Group className="radio-text-content">
                            {topicTypeMap.map((item, index) => (
                                <Radio.Button key={index} value={item.value}>
                                    {item.label}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="content" label="配置问题" rules={[{ required: true, message: '题目内容不能为空' }]}>
                        <Input placeholder="请输入题目内容" maxLength={1000} showCount />
                    </Form.Item>

                    {topicType === 'radio' && (
                        <>
                            <Form.List name="options" label="选项" initialValue={[{ content: '' }, { content: '' }, { content: '' }, { content: '' }]}>
                                {(fields, { add, remove }) => (
                                    <>
                                        <Radio.Group>
                                            <Space orientation="vertical">
                                                {fields.map(({ key, name, ...restField }, index) => (
                                                    <Radio value={index} key={key} disabled>
                                                        <div className="radio-right">
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'content']}
                                                                validateTrigger={['onChange', 'onBlur']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        whitespace: true,
                                                                        message: '选项内容不能为空',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input placeholder="请输入选项内容" maxLength={1000} showCount />
                                                            </Form.Item>

                                                            {fields.length > 1 ? (
                                                                <span
                                                                    className="anticon dynamic-delete-button"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        if (fields.length === 2) {
                                                                            return message.warning('最少支持2个选项');
                                                                        }
                                                                        Modal.confirm({
                                                                            title: '提示',
                                                                            icon: <i className="bi bi-exclamation-circle"></i>,
                                                                            content: `确认删除该选项？`,
                                                                            okText: '确认',
                                                                            centered: true,
                                                                            cancelText: '取消',
                                                                            onOk: () => {
                                                                                remove(name);
                                                                            },
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="bi bi-dash-circle"></i>
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </Radio>
                                                ))}
                                            </Space>
                                        </Radio.Group>

                                        <Form.Item>
                                            <Button
                                                className="add-options-btn"
                                                type="primary"
                                                ghost
                                                onClick={e => {
                                                    e.preventDefault();
                                                    if (fields.length === 26) {
                                                        return message.warning('最多支持26个选项');
                                                    }
                                                    add();
                                                }}
                                            >
                                                新增选项
                                            </Button>
                                        </Form.Item>

                                        {form.getFieldError('options') && <div style={{ color: 'red' }}>{form.getFieldError('options').join(', ')}</div>}
                                    </>
                                )}
                            </Form.List>
                        </>
                    )}
                    {topicType === 'checkbox' && (
                        <>
                            <Form.List name="options" label="选项" initialValue={[{ content: '' }, { content: '' }, { content: '' }, { content: '' }]}>
                                {(fields, { add, remove }) => (
                                    <>
                                        <Radio.Group>
                                            <Space orientation="vertical">
                                                {fields.map(({ key, name, ...restField }, index) => (
                                                    <Checkbox key={key} disabled>
                                                        <div className="radio-right">
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'content']}
                                                                validateTrigger={['onChange', 'onBlur']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        whitespace: true,
                                                                        message: '选项内容不能为空',
                                                                    },
                                                                ]}
                                                            >
                                                                <Input placeholder="请输入选项内容" maxLength={200} />
                                                            </Form.Item>

                                                            {fields.length > 1 ? (
                                                                <span
                                                                    className="anticon dynamic-delete-button"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        if (fields.length === 2) {
                                                                            return message.warning('最少支持2个选项');
                                                                        }
                                                                        remove(name);
                                                                    }}
                                                                >
                                                                    <i className="bi bi-dash-circle"></i>
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </Checkbox>
                                                ))}
                                            </Space>
                                        </Radio.Group>

                                        <Form.Item>
                                            <Button
                                                className="add-options-btn"
                                                type="primary"
                                                ghost
                                                onClick={e => {
                                                    e.preventDefault();
                                                    if (fields.length === 26) {
                                                        return message.warning('最多支持26个选项');
                                                    }
                                                    add();
                                                }}
                                            >
                                                新增选项
                                            </Button>
                                        </Form.Item>

                                        {form.getFieldError('options') && <div style={{ color: 'red' }}>{form.getFieldError('options').join(', ')}</div>}
                                    </>
                                )}
                            </Form.List>
                        </>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default TemplateQuestions;
